import { useTranslations } from '@aikoa/i18n/react'
import { useLocalSearchParams, useRouter } from 'expo-router'
import { useCallback } from 'react'
import { ContactFlow } from '~/components/contacts/ContactFlow'
import ScreenView from '~/components/layout/ScreenView'
import { LoadingView } from '~/components/LoadingView'
import { Text } from '~/components/ui/text'
import { useContact } from '~/data/contacts/useContacts'
import { useLead } from '~/data/leads/useLeads'

export default function EditLeadContactPage() {
  const { t } = useTranslations('leads')
  const router = useRouter()

  const { leadId } = useLocalSearchParams<{
    leadId: string
  }>()

  const { data: lead, isLoading: isLoadingLead } = useLead(leadId)

  const ownedContactId = lead?.ownedContactId ?? leadId
  const { data: contact, isLoading: isLoadingContact } = useContact(ownedContactId)

  const handleFlowComplete = useCallback(() => {
    router.replace({
      pathname: '/leads/[leadId]',
      params: { leadId },
    })
  }, [router, leadId])

  const isLoading = isLoadingLead || isLoadingContact

  return (
    <ScreenView>
      {isLoading ? (
        <LoadingView />
      ) : !contact ? (
        <Text>{t(($) => $.errors.contactNotFound)}</Text>
      ) : (
        <ContactFlow
          contact={contact}
          onContactSaved={handleFlowComplete}
          onCancel={handleFlowComplete}
        />
      )}
    </ScreenView>
  )
}
